// extracted by mini-css-extract-plugin
module.exports = {"feedLayout":"page_feedLayout__8HE19","pageContainer":"page_pageContainer__QT1rr"};